import React, { useState } from "react";

// Libraries & Packages
import { useThemeStore } from "utils/state/Store";

// Utils
import CommonUtils from "components/UI/Utils/CommonUtils";
import { COMMON_MARGIN_SIZES } from "components/UI/Utils/CommonConstants";
import ButtonUtils from "./ButtonUtils";

function Button({
  borderRadius = "xs",
  children,
  leftIcon,
  onClick,
  rightIcon,
  size = "xl",
  type = "primary",
  variant = "solid",
  width,
}) {
  // State
  const { theme } = useThemeStore();
  const [isHovered, setIsHovered] = useState(false);

  // Styles
  var styles = {
    button: {
      // Bacground
      backgroundColor: ButtonUtils.getButtonColorStyles(
        isHovered,
        theme,
        type,
        variant
      ).backgroundColor,
      //   transition: "0.25s background-color ease-in-out",
      // Border
      border: "2px solid",
      borderRadius:
        CommonUtils.getCommonBorderStyles(borderRadius).borderRadius,
      borderColor: ButtonUtils.getButtonColorStyles(
        isHovered,
        theme,
        type,
        variant
      ).borderColor,
      //   transition: "0.25s border-color ease-in-out",
      // Font
      color: ButtonUtils.getButtonColorStyles(isHovered, theme, type, variant)
        .color,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "Argesta-Display",
      fontSize: CommonUtils.getCommonFontStyles(size).fontSize,
      fontWeight: "bold",
      // Miscellaneous
      cursor: "pointer",
      transition:
        "0.25s background-color ease-in-out,0.25s border-color ease-in-out",
      // Size
      height: ButtonUtils.getButtonSizeStyles(size).height,
      minWidth: ButtonUtils.getButtonSizeStyles(size).minWidth,
      width: width,
      // Spacing
      padding: ButtonUtils.getButtonSpacingStyles(size).padding,
    },
    leftIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      marginRight: leftIcon && COMMON_MARGIN_SIZES.sm,
    },
    rightIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "auto",
      height: "100%",
      marginLeft: rightIcon && COMMON_MARGIN_SIZES.sm,
    },
  };

  return (
    <button
      style={styles.button}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick && (() => onClick())}
    >
      <span style={styles.leftIcon}>{leftIcon}</span>
      {children}
      <span style={styles.rightIcon}>{rightIcon}</span>
    </button>
  );
}

export default Button;
